class CurrentState {
  obj = {};

  apply = data => {
    this.obj = data;
  };

  add = (componentName, key, value, componentId = null) => {
    if (!this.obj[componentName]) {
      this.obj[componentName] = {};
    }
    if (componentId) {
      if (!this.obj[componentName][componentId]) {
        this.obj[componentName][componentId] = {};
      }
      this.obj[componentName][componentId][key] = value;
    } else {
      this.obj[componentName][key] = value;
    }
  };

  get = (componentName, key, componentId = null) => {
    if (componentId) {
      return (
        this.obj &&
        this.obj[componentName] &&
        this.obj[componentName][componentId] &&
        this.obj[componentName][componentId][key]
      );
    }
    return this.obj && this.obj[componentName] && this.obj[componentName][key];
  };

  getAll = () => {
    return this.obj;
  };

  delete = (componentName, componentId) => {
    if (this.obj[componentName] && this.obj[componentName][componentId]) {
      this.obj[componentName][componentId] = null;
      delete this.obj[componentName][componentId];
    }
  };

  deleteAll = () => {
    this.obj = null;
    delete this.obj;
  };
}

export default new CurrentState();
